
$(".size-cm-btn").on('click', function(){
    $(".size-guide__cm").show();
    $(".size-guide__inch").hide();

    // Toggle active class
    $(this).addClass("btn-active");
    $(".size-inch-btn").removeClass("btn-active");
});

$(".size-inch-btn").on('click', function(){
    $(".size-guide__inch").show();
    $(".size-guide__cm").hide();

    // Toggle active class
    $(this).addClass("btn-active");
    $(".size-cm-btn").removeClass("btn-active");
});

$(document).ready(function() {
    // Get the value of the data-tag attribute
    var dataTag = $('.z21-fitting-details').data('tag');

    // Iterate over each fitting-details-btn
    $('.fitting-details-btn').each(function() {
        // Check if the id matches the data-tag value
        if ($(this).attr('id') === dataTag) {
            // Add the 'active' class
            $(this).addClass('active');
        }
    });
});

